export const WHAT_MAKES_COURSE_DIFFERENT_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_title: "Retirement Planning Case study ",
    meta_title_color: "#000000",
    meta_sub_title: "Build a 30-year retirement corpus strategy for a 40-year-old professional with ₹50L annual income",
    meta_sub_title_color: "#000000CC",
    meta_image: "",
    meta_alt_image: "",
    meta_logo: "",
    meta_alt_logo: "",
    meta_priority: 1,
    meta_status: 1,
  },

  METADATA_TITLES: {
    metadata: "What Makes Course Different Cards",
  },

  WHAT_MAKES_COURSE_DIFFERENT_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select background variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#5345C3",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Solve actual wealth",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter pre title",
      required: false,
      defaultValue: "Solve actual wealth",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "management challenges",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title",
      required: false,
      defaultValue: "management challenges",
    },
    {
      fieldName: "title_start_color",
      label: "Title Start Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#342B7C",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "title_end_color",
      label: "Title End Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#342B7C",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "Work through real client scenarios—from building multi-generational wealth plans to navigating market volatility, tax law changes, and complex insurance needs faced by high-net-worth individuals.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue:
        "Work through real client scenarios—from building multi-generational wealth plans to navigating market volatility, tax law changes, and complex insurance needs faced by high-net-worth individuals.",
    },
    {
      fieldName: "description_text_color",
      label: "Description Text Color",
      value: "#000000B2",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000B2",
      required: false,
      defaultValue: "#000000B2",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload right navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_right_nav_icon",
      label: "Right Navigation Icon Alt Text",
      value: "icon 1",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter right icon alt text",
      required: false,
      defaultValue: "icon 1",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload left navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_left_icon",
      label: "Left Navigation Icon Alt Text",
      value: "icon 2",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter left icon alt text",
      required: false,
      defaultValue: "icon 2",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_start_color",
      label: "CTA Start Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#02A7B6",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "cta_end_color",
      label: "CTA End Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#342B7C",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "cta_gradient_angle",
      label: "CTA Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter card title",
      required: false,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#222222",
      defaultValue: "#222222",
    },
    {
      header: "Sub Title",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter card subtitle",
      required: false,
    },
    {
      header: "Sub Title Color",
      fieldName: "meta_sub_title_color",
      value: "#000000CC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000CC",
      defaultValue: "#000000CC",
    },
    {
      header: "Image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload image",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt image text",
    },
    {
      header: "Logo",
      fieldName: "meta_logo",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo",
    },
    {
      header: "Alt Logo",
      fieldName: "meta_alt_logo",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt logo text",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable What Makes Course Different",
      defaultValue: true,
    },
  ],
};
